import styled from 'styled-components';
import { FlexColumn, FlexibleDiv } from '../../styled/common';
import { globalSystemColors as systemColors } from '../../styled/theme/constants';

export const SelectedButton = styled(FlexibleDiv)`
  gap: 11px;
  align-items: center;
  position: relative;
  cursor: pointer;
  height: 40px;
  padding: 10px 15px;
  border-radius: 7px;
  background: ${({ theme }) => theme.colors.background.tertiary};
`;

export const SelectedButtonUserIcon = styled.i`
  svg circle {
    fill: ${({ theme }) => theme.colors.background.primary};
    stroke: ${({ theme }) => theme.colors.background.primary};
  }

  svg path {
    fill: ${systemColors.blue};
  }
`;

export const SelectedButtonArrowIcon = styled.i`
  width: 14px;
  text-align: center;

  svg {
    transform: rotate(90deg);
  }

  svg path {
    fill: ${systemColors.blue};
  }
`;

export const DropdownItemsContainer = styled(FlexColumn)`
  position: absolute;
  z-index: 9999;
  top: 35px;
  left: 50%;
  transform: translateX(-50%);
  padding-top: 10px;
  width: max-content;
`;

export const DropdownItem = styled.div`
  padding: 10px;
  text-align: center;
  align-items: center;
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.background.tertiary};

  &:first-child {
    border-radius: 7px 7px 0 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};
  }

  &:last-child {
    border-radius: 0 0 7px 7px;
  }
`;

export const DropDownProfileLink = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.text.primary};
`;
